<div class="row ms-0 me-0 mt-1 mb-1">
    <rb-tab-panel class="full-width ps-0 pe-0 ms-0 me-0">
        <div *rbTabPanelItem="'Passenger Car'" class="content vehicles-table">
            <div class="row ms-0 me-0 mt-0 mb-0">
                <div class="col-12">
                    <table class="m-table" *rbTable="loader; fixedHeaderWidth: false; columns: 5; maxHeight: '60vh'" [rbSort]="{id: '', direction: ''}" (rbSortChange)="supportedVehicles = sortData($event, supportedVehicles)">
                        <thead>
                            <tr>
                                <th rb-sort-header="vehicleBrand" [disableSortClear]="true">Vehicle Brand</th>
                                <th rb-sort-header="vehicleModel" [disableSortClear]="true">Vehicle Model</th>
                                <th>Vehicle Type</th>
                                <th>Battery Energy (gross / net)</th>
                                <th rb-sort-header="modelYear" [disableSortClear]="true">Model Year</th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngFor="let vehicle of supportedVehicles; let i = index">
                                <tr>
                                    <td>{{ vehicle.vehicleBrand }}</td>
                                    <td>{{ vehicle.vehicleModel }}</td>
                                    <td>{{ vehicle.vehicleType }}</td>
                                    <td>{{ vehicle.batteryCapacityGross }} kWh / {{ vehicle.batteryCapacityNet }} kWh</td>
                                    <td>{{ vehicle.modelYear.join(', ') }}</td>
                                </tr>
                            </ng-container>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div *rbTabPanelItem="'Commercial Vehicle'" class="content vehicles-table">
            <div class="row ms-0 me-0 mt-0 mb-0">
                <div class="col-12">
                    <table class="m-table" *rbTable="loader; fixedHeaderWidth: false; columns: 5; maxHeight: '60vh'" [rbSort]="{id: '', direction: ''}" (rbSortChange)="supportedCommercialVehicles = sortData($event, supportedCommercialVehicles)">
                        <thead>
                            <tr>
                                <th rb-sort-header="vehicleBrand" [disableSortClear]="true">Vehicle Brand</th>
                                <th rb-sort-header="vehicleModel" [disableSortClear]="true">Vehicle Model</th>
                                <th>Vehicle Type</th>
                                <th>Battery Capacity</th>
                                <th rb-sort-header="modelYear" [disableSortClear]="true">Model Year</th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngFor="let vehicle of supportedCommercialVehicles; let i = index">
                                <tr>
                                    <td>{{ vehicle.vehicleBrand }}</td>
                                    <td>{{ vehicle.vehicleModel }}</td>
                                    <td>{{ vehicle.vehicleType }}</td>
                                    <td>
                                        <span *ngIf="vehicle.batteryCapacityNet">{{ vehicle.batteryCapacityGross }} / {{ vehicle.batteryCapacityNet }} kWh</span>
                                        <span *ngIf="!vehicle.batteryCapacityNet">{{ vehicle.batteryCapacity }} kWh</span>
                                    </td>
                                    <td>{{ vehicle.modelYear.join(', ') }}</td>
                                </tr>
                            </ng-container>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </rb-tab-panel>
</div>
